import type { FaireProductEntity } from "../../entity_types/product";

export const p_herdmat4jc: FaireProductEntity = {
  token: "p_herdmat4jc",
  type: "product",
  name: "I ❤️ Mac N Cheese Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/cdbc8b911a58dd0186d82685884ec1d9a58759149938806415eb9c8f4e0eabdb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/daccf9f81e4c1f067124eb5e4649082d4fb1320983aa5583f7150abcf6e83662.jpeg",
    "https://cdn.faire.com/fastly/8d3fb40abc3c6d7058049be8af7462b1f0a9fe5941c2bc6034df03ba0363ef27.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/3d792f776b6198f9b63a7569a9d5932677015a742069c80be96701dd41aafc6e.jpeg",
    "https://cdn.faire.com/fastly/2da40174ed615595536aa6a39bcc3e3832e3c320815e3ebd95cc77b032eb1090.jpeg"
  ],
  priceDollars: 6.75,
  description: "Anyone with a soul knows that Mac ’n Cheese will warm theirs 💕. Whether you like it gourmet with a little baked cheese roof and garnish, or you’re just buying the instant boxes so you can go to town on those little cheese dust packets… your love is valid. It is warm. It is saucy 🧀🧀🧀. Let these socks warm your feet while you fill your tummy 😋.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:30:58.087Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
